<script>
  import DatePicker from './Flatpickr/DatePicker.svelte';
  import ReminderListItem from './ReminderListItem.svelte';
  import FormTextarea from './FormControls/FormTextarea.svelte';
  import { getContext } from 'svelte';
  import { client } from 'root/api/index.js';
  import Loader from './Loader.svelte';
  import InfiniteScroll from './DataTable/InfiniteScroll.svelte';
  import { configItem, displayTimeAgo } from 'components/Helper.js';
  import FormInput from './FormControls/FormInput.svelte';
  const showDialog = getContext('showDialog');
  let defaultValue = {
    id: '',
    taskId: '',
    notes: '',
    reminderAt: '',
    reminder: '',
  };
  let errors = {
    notes: '',
    reminderAt: '',
  };
  let reminderValues = { ...defaultValue };
  let isFormPending = false;
  export let id = 0;
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let taskReminderData = [];
  let isPaginationLoading = false;
  export const show = (taskId) => {
    pageNumber = 1;
    totalPages = 0;
    taskReminderData = [];
    id = taskId;
    reminderValues.taskId = id;
    getReminderList();
  };
  const getReminderList = () => {
    if (id == 0) {
      return;
    }
    isPaginationLoading = true;
    client
      .taskReminderList(pageSize, pageNumber, { taskId: id })
      .then((response) => {
        isPaginationLoading = false;
        taskReminderData = taskReminderData.concat(response.data.payload);
        totalPages = response.data.pagination.totalPage;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const handleSubmit = () => {
    if (reminderValues.notes == '') {
      errors.notes = 'Enter Reminder Note';
    }
    if (reminderValues.reminderAt == '') {
      errors.reminderAt = true;
    }
    if (errors.notes != '' || errors.reminderAt == true) {
      return;
    }

    isFormPending = true;
    client
      .taskReminderSave({ ...reminderValues })
      .then((response) => {
        isFormPending = false;
        reminderValues = { ...defaultValue };
        show(id);
      })
      .catch((err) => {
        isFormPending = false;
        showDialog({ message: err.message });
      });
  };
  function showDelete(selectId) {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure ?',
      okFunc: () => {
        client
          .taskReminderDelete({ id: selectId })
          .then((response) => {
            show(id);
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  }
</script>

<div class="page-content p-3">
  <div class="w-100">
    <div class="text-end">
      <button
        data-bs-toggle="collapse"
        href="#collapseExample"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample"
        class="btn btn-link color-blue border-0 shadow-none font-size-12 py-0 px-0 bg-transparent font-weight-500 mb-3"
        >+ Add Reminder</button
      >
    </div>
    <div
      class="collapse"
      id="collapseExample"
    >
      <div class="reminder-block mb-3">
        <div class="text-end">
          <button
            type="button"
            class="btn-close"
            data-bs-toggle="collapse"
            href="#collapseExample"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample"
          ></button>
        </div>
        <div class="form-group mb-3">
          <FormTextarea
            id="notes"
            label="Notes"
            maxLength={configItem.maxLength.description}
            placeholder="Enter Reminder Notes..."
            error={errors.notes}
            bind:value={reminderValues.notes}
            on:onHandleChange={() => (errors.notes = '')}
            on:onHandleInput={() => (errors.notes = '')}
          />
        </div>
        <div class="row justify-content-between">
          <div class="col-md-3">
            <div class="form-group mb-3 position-relative {errors.reminderAt ? 'error' : ''}">
              <label
                for=""
                class="form-label">Select Date</label
              >
              <DatePicker
                style="active select-border bg-white"
                timeEnable={true}
                bind:value={reminderValues.reminder}
                on:change={(value) => {
                  if (value.detail[1] != '') {
                    reminderValues.reminderAt = value.detail[1];
                    reminderValues.reminder = value.detail[1];
                    errors.reminderAt = false;
                  }
                }}
                on:close={(value) => {
                  if (value.detail[1] != '') {
                    reminderValues.reminder = value.detail[1];
                    reminderValues.reminderAt = value.detail[1];
                    errors.reminderAt = false;
                  }
                }}
              />
              {#if errors.reminderAt}
                <label class="formError">Select Date</label>
              {/if}
            </div>
          </div>
          <!-- <div class="col-md-3">
			  <div class="form-group mb-3">
				<FormInput
				style="active  select-border bg-white"
				label="Select Time"
				type="text"
				placeholder="Enter Time"
				name="time"
				bind:value={reminderValues.reminderTime}
				on:onHandleInput={()=>errors.reminderTime = false}
			  />
			</div>
			{#if errors.reminderTime}
			  <label class="error">Select time</label>
			{/if}
			</div> -->
          <div class="col-md-6 text-end">
            <button
              class="btn shadow-none btn-primary background-blue mb-0 text-white add-task px-4 add-reminder font-size-12"
              on:click={handleSubmit}>+ Add</button
            >
          </div>
        </div>
      </div>
    </div>
    {#if taskReminderData.length <= 0 && !isPaginationLoading}
      <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
        <svg
          width="55"
          height="55"
          viewBox="0 0 100 100"
          fill="#C8D6E7"
          xmlns="http://www.w3.org/2000/svg"
          ><path
            d="M50 100C45.9635 100 42.0898 99.4792 38.3789 98.4375C34.668 97.3958 31.1849 95.931 27.9297 94.043C24.6745 92.1549 21.7285 89.8763 19.0918 87.207C16.4551 84.5378 14.1764 81.5918 12.2559 78.3691C10.3353 75.1465 8.85417 71.6634 7.8125 67.9199C6.77083 64.1764 6.25 60.2865 6.25 56.25C6.25 52.2135 6.77083 48.3398 7.8125 44.6289C8.85417 40.918 10.319 37.4349 12.207 34.1797C14.0951 30.9245 16.3737 27.9785 19.043 25.3418C21.7122 22.7051 24.6582 20.4264 27.8809 18.5059C31.1035 16.5853 34.5866 15.1042 38.3301 14.0625C42.0736 13.0208 45.9635 12.5 50 12.5C54.0365 12.5 57.9102 13.0208 61.6211 14.0625C65.332 15.1042 68.8151 16.569 72.0703 18.457C75.3255 20.3451 78.2715 22.6237 80.9082 25.293C83.5449 27.9622 85.8236 30.9082 87.7441 34.1309C89.6647 37.3535 91.1458 40.8366 92.1875 44.5801C93.2292 48.3236 93.75 52.2135 93.75 56.25C93.75 60.2865 93.2292 64.1602 92.1875 67.8711C91.1458 71.582 89.681 75.0651 87.793 78.3203C85.9049 81.5755 83.6263 84.5215 80.957 87.1582C78.2878 89.7949 75.3418 92.0736 72.1191 93.9941C68.8965 95.9147 65.4134 97.3958 61.6699 98.4375C57.9264 99.4792 54.0365 100 50 100ZM50 18.75C44.8242 18.75 39.974 19.7266 35.4492 21.6797C30.9245 23.6328 26.9531 26.3184 23.5352 29.7363C20.1172 33.1543 17.4316 37.1257 15.4785 41.6504C13.5254 46.1751 12.5326 51.0417 12.5 56.25C12.5 61.4258 13.4766 66.276 15.4297 70.8008C17.3828 75.3255 20.0684 79.2969 23.4863 82.7148C26.9043 86.1328 30.8757 88.8184 35.4004 90.7715C39.9251 92.7246 44.7917 93.7174 50 93.75C55.1758 93.75 60.026 92.7734 64.5508 90.8203C69.0755 88.8672 73.0469 86.1816 76.4648 82.7637C79.8828 79.3457 82.5684 75.3743 84.5215 70.8496C86.4746 66.3249 87.4674 61.4583 87.5 56.25C87.5 51.0742 86.5234 46.224 84.5703 41.6992C82.6172 37.1745 79.9316 33.2031 76.5137 29.7852C73.0957 26.3672 69.1243 23.6816 64.5996 21.7285C60.0749 19.7754 55.2083 18.7826 50 18.75ZM50 56.25V31.25H43.75V62.5H68.75V56.25H50Z"
            fill=""
          /></svg
        >
        <span class="color-lead font-size-18 mt-2 d-block">There is no task reminder yet</span>
      </div>
    {/if}
    {#each taskReminderData as itemData, itemkey}
      <ReminderListItem
        time={itemData.reminderAtTZ}
        note={itemData.notes}
        on:onClick={() => {
          showDelete(itemData.id);
        }}
      />
    {/each}
  </div>

  <InfiniteScroll
    threshold={300}
    hasMore={pageNumber < totalPages}
    isLoading={isPaginationLoading}
    on:loadMore={() => {
      pageNumber = pageNumber + 1;
      getReminderList();
    }}
  >
    <div
      class="scroll-spinner-container d-flex justify-content-center
			  align-items-center"
    >
      <Loader Style="loader-block" />
    </div>
  </InfiniteScroll>
</div>

<style lang="scss">
  .reminder-block {
    background-color: rgba($input-border-color, 0.5);
    padding: 24px;
    border-radius: 12px;
  }
  .add-reminder {
    margin-top: 28px;
  }
</style>
